import React from 'react';
import {IndexLink, Link} from 'react-router';

var $ = require('jquery');
export default class Splash_Forgot extends React.Component {
    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            user: {email: '', disabled: false}
        };
    }


    handleChange(propertyName, event) {
        const user = this.state.user;
        user[propertyName] = event.target.value;
        this.setState({user: user});
    };

    handleSubmit(event) {
        event.preventDefault();
        const user = this.state.user;
        user['api'] = 'forgot';
        const email = this.state.user.email.trim();

        if (!email) {
            return;
        }
        this.state.user.disabled = true;
        $.ajax({
            url: this.props.url,
            dataType: 'json',
            type: 'POST',
            data: user,
            success: function (data) {
                console.log(data);
                if (data.status == 1) {
                    this.setState({user: {email: '', disabled: false}});
                    this.props.openDialog(data.message);
                }
                else {
                    this.props.openDialog(data.message);
                    //console.log('alert here');
                }
                this.state.user.disabled = false;

            }.bind(this),
            error: function (xhr, status, err) {
                console.error(this.props.url, status, err.toString());
                this.state.user.disabled = false;
            }.bind(this)
        });
        //user[propertyName] = event.target.value;
    };

    render() {
        if (this.props.isMobile == 1) {
            return (
                <form onSubmit={this.handleSubmit}>
                    <div className="account_box_wrappers">
                        <div className={"forgot"}>
                            <div className={"content"}>
                                <h3>First, let’s find your account</h3>
                                <small>Please enter your email </small>
                                <label>Enter your email *</label>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    className={"form-control input-lg"}
                                    onChange={this.handleChange.bind(this, 'email')}
                                    value={this.state.user.email}
                                    required name="e"/>
                                <p>&nbsp;</p>

                                <Link className={"btn btn-lg btn-default"} to="/signin">Cancel</Link>
                                <input
                                    type="submit"
                                    disabled={this.state.user.disabled}
                                    value="Find account"
                                    className={"btn btn-lg btn-primary"}
                                    name="ffpass"/>
                            </div>
                        </div>
                    </div>
                </form>
            )
        }
        return (
            <form onSubmit={this.handleSubmit} className="class-form-forgot">
                <div className="account_box_wrappers pc-forgot">
                    <h2>Password Reset</h2>
                    <p className="text01">Enter your email address and we'll get you back on track.</p>
                    <p className="input01">
                        <input
                            type="email"
                            placeholder="Email"
                            onChange={this.handleChange.bind(this, 'email')}
                            value={this.state.user.email}
                            required name="e"/>
                    </p>
                    <p className="btn01">
                        <input
                            type="submit"
                            disabled={this.state.user.disabled}
                            value="REQUEST RESET LINK"
                            name="ffpass"/>
                    </p>
                    <Link className={"btn03"} to="/signin">Back to Log in</Link>
                </div>
            </form>
        )
    }
};



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_forgot.js
 **/